import { useState } from 'react';
import preRegistrationService from '../services/onboarding/preRegistrationService';
import { useMediaQuery } from 'react-responsive';

// Helper function to clean data and remove circular references
const cleanDataForAPI = (data) => {
  try {
    // Convert to JSON and back to remove circular references
    return JSON.parse(JSON.stringify(data));
  } catch (error) {
    console.warn('Error cleaning data for API:', error);
    // If JSON.stringify fails, create a clean object with only primitive values
    const cleanObject = {};
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (value !== null && typeof value !== 'function' && typeof value !== 'object' && typeof value !== 'undefined') {
        cleanObject[key] = value;
      } else if (typeof value === 'object' && value !== null) {
        try {
          // Try to clean nested objects
          const cleaned = cleanDataForAPI(value);
          if (Object.keys(cleaned).length > 0) {
            cleanObject[key] = cleaned;
          }
        } catch (e) {
          // Skip this property if it can't be cleaned
          console.warn(`Skipping property ${key} due to circular reference`);
        }
      }
    });
    return cleanObject;
  }
};

const useOnboarding = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [sessionData, setSessionData] = useState({});
  const [userEmail, setUserEmail] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  console.log(userEmail, userPhone, 'userEmail1, userPhone2');

  const totalSteps = 5;

  let isMobile = useMediaQuery({ maxWidth: 480 });
  let isIPad = useMediaQuery({ minWidth: 768, maxWidth: 1024 });

  const saveStepData = async (stepData) => {
    try {
      setIsLoading(true);
      setError(null);

      console.log('saveStepData called with:', stepData);
      console.log('Current sessionData:', sessionData);

      // Update session data with new step data, preserving step structure
      const updatedSessionData = {
        ...sessionData,
        ...stepData, // This preserves the step objects like personalInfo, businessDetails, etc.
      };
      setSessionData(updatedSessionData);

      console.log('Updated sessionData:', updatedSessionData);

      // Call preRegister API
      console.log('Calling savePreRegistrationData...');
      await preRegistrationService.savePreRegistrationData(userEmail, userPhone, updatedSessionData);
      console.log('savePreRegistrationData completed successfully');

      // If this is the final step (step 5), call the registration API
      if (currentStep === 5) {
        console.log('Final step completed, calling registration API...');
        try {
          const registrationResult = await preRegistrationService.registerAutomatedKYCUser(
            updatedSessionData,
            isMobile,
            isIPad,
          );
          console.log('Registration API response:', registrationResult);

          // Check if registration was successful based on API response
          if (registrationResult && registrationResult.is_registered === true) {
            console.log('Registration API completed successfully:', registrationResult.message);
            // Persist onboarded company id immediately for subsequent payloads
            try {
              const companyId =
                registrationResult?.onboarded_company_id || registrationResult?.data?.onboarded_company_id;
              if (companyId) {
                localStorage.setItem('onboardedCompanyId', String(companyId));
              }
            } catch (e) {
              // noop
            }

            // Return success status to indicate registration was successful
            return { success: true, registrationData: registrationResult };
          } else {
            console.error('Registration API returned failure response:', registrationResult);
            throw new Error(registrationResult?.message || 'Registration failed');
          }
        } catch (registrationError) {
          console.error('Registration API failed:', registrationError);
          // Registration failed, but data was saved - this is a partial success
          throw new Error(
            `Registration failed: ${registrationError.message}. Your data has been saved but account creation was unsuccessful.`,
          );
        }
      }

      return { success: true };
    } catch (error) {
      console.error('saveStepData error:', error);
      const errors = error.errors;
      // Get the first error message from the errors object
      const firstErrorKey = Object.keys(errors)[0];
      const firstErrorMessage = errors[firstErrorKey];
      // console.log('FirstErrorMessage', firstErrorMessage, errors, firstErrorKey);
      setError(firstErrorMessage || error.message || 'Failed to save step data');
      return { success: false, error: firstErrorMessage || error.message };
    } finally {
      setIsLoading(false);
    }
  };

  const nextStep = async (stepData) => {
    if (stepData) {
      const result = await saveStepData(stepData);
      if (!result.success) {
        return result; // Return the error result
      }
      setCurrentStep((prev) => prev + 1);
      return result; // Return the success result
    }
    setCurrentStep((prev) => prev + 1);
    return { success: true };
  };

  const prevStep = () => {
    setCurrentStep((prev) => prev - 1);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
  };

  const setUserData = (email, phone) => {
    setUserEmail(email);
    setUserPhone(phone);
  };
  // Added setError
  return {
    currentStep,
    totalSteps,
    sessionData,
    userEmail,
    userPhone,
    isLoading,
    error,
    setError,
    nextStep,
    prevStep,
    setUserData,
  };
};

export default useOnboarding;
